// extracted by mini-css-extract-plugin
module.exports = {"limitedEdition":"LimitedPerk_limitedEdition__H3XvE","star":"LimitedPerk_star__rS2NY"};